import { ref } from 'vue';

const isVisible = ref(false);
let observer = null;

export const spinnerLoader = {
  show() {
    isVisible.value = true;
    if (observer) observer(isVisible.value);
  },
  hide() {
    isVisible.value = false;
    if (observer) observer(isVisible.value);
  },
  register(loaderRef) {
    observer = (value) => {
      loaderRef.value = value;
    };
    observer(isVisible.value);
  },
  unregister() {
    observer = null;
  }
};